import { Tooltip } from "@zapier/design-system-beta";
import { Icon } from "@zapier/zinnia-icons";
import styles from "./SidebarListItem.module.css";

/**
 * The icon which sits inside the input field.
 */

const CONTENT = "Clear selection";

export const ClearSelectionButton = ({
  clearSelection,
}: {
  clearSelection: () => void;
}) => {
  return (
    <Tooltip placement="left" content={CONTENT}>
      <Tooltip.FocusableTrigger>
        <button
          aria-label={CONTENT}
          type="button"
          className={styles.clearSelectionButton}
          onClick={clearSelection}
          title="Clear selection"
        >
          <Icon canAcceptPointerEvents={false} name="formXCircle" size={20} />
        </button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
};
